import React from 'react'
import { compose, withState, withHandlers } from 'recompose'
import Checkbox from '@mui/material/Checkbox'
import Filter from './Filter'
import FilterActions from './FilterActions'
import CheckboxQuickFilter from './CheckboxQuickFilter'
import { formatOccupationGroupName } from '../../formatting'
import FormControlLabel from '@mui/material/FormControlLabel'
import { withStyles } from '@mui/styles'
import CardContent from '@mui/material/CardContent'

export const getOccupationGroupsHeader = occupationGroups => {
	let combineString = ''
	let checkedCount = 0

	occupationGroups.groups.forEach(m => {
		if (m.selected) {
			checkedCount++

			if (checkedCount !== 1) combineString += ', '

			combineString += m.name
		}
	})

	return checkedCount == occupationGroups.groups.length ? 'All occupation groups' : combineString || 'None'
}

export const mapChecked = (group, checkedType, checked) => ({
	...group,
	selected: group.type === checkedType ? checked : group.selected,
})

const styles = {
	formLabelRoot: {
		height: 'auto',
	},
	formLabelLabel: {
		lineHeight: '1 !important',
		padding: '4px 0',
	},
}

export const OccupationGroupFilter = ({
	search,
	occupationGroups,
	setOccupationGroups,
	onSave,
	onCancel,
	onHoverEnter,
	onHoverLeave,
	selectGroupAndSave,
	hoveredOption,
	classes
}) => (
	<Filter
		filterObj={search.filter.occupationGroups}
		filterState={occupationGroups}
		setFilterState={setOccupationGroups}
		title="Occupation groups"
		subtitle={getOccupationGroupsHeader(occupationGroups)}
		content={
			<CardContent style={{ padding: '0px' }}>
				<div style={{ padding: '31px 44px 39px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px' }}>
					{occupationGroups.groups.map(v => (
						<div
							key={v.type}
							onMouseEnter={() => onHoverEnter(v)}
							onMouseLeave={() => onHoverLeave()}
							style={{ position: 'relative' }}
						>
							<FormControlLabel
								classes={{ root: classes.formLabelRoot, label: classes.formLabelLabel }}
								value="v.type"
								control={
									<Checkbox
										label={v.name}
										checked={v.selected}
										style={{ padding: '0px 12px' }}
										onChange={(e, checked) =>
											setOccupationGroups({
												...occupationGroups,
												groups: occupationGroups.groups.map(s =>
													mapChecked(s, v.type, checked)
												),
											})}
									/>
								}
								label={v.name}
							/>
							<CheckboxQuickFilter
								show={hoveredOption === v.type}
								onSelect={() => selectGroupAndSave(v.type)}
							/>
						</div>
					))}
				</div>
				<FilterActions
					expanded={occupationGroups.expanded}
					primaryLabel="Save"
					primaryAction={onSave}
					secondaryLabel="Cancel"
					secondaryAction={onCancel}
					disabled={!occupationGroups.groups.filter(s => s.selected).length}
				/>
			</CardContent>
		}
	/>
)

const enhance = compose(
	withState('occupationGroups', 'setOccupationGroups', props => props.search.filter.occupationGroups),
	withState('hoveredOption', 'setHoveredOption', props => null),
	withHandlers({
		selectGroupAndSave: props => groupType => {
			let selectedGroups = props.occupationGroups.groups.map(s => ({ ...s, selected: s.type === groupType }))
			let newGroups = { ...props.occupationGroups, groups: selectedGroups, expanded: false }
			let updated = { ...props.search, filter: { ...props.search.filter, occupationGroups: newGroups } }

			props.onUpdate(updated)
			props.setOccupationGroups(updated.filter.occupationGroups)
		},
		onHoverEnter: props => option => {
			props.setHoveredOption(option.type)
		},
		onHoverLeave: props => () => {
			props.setHoveredOption(null)
		},
		onSave: props => () => {
			let updated = {
				...props.search,
				filter: { ...props.search.filter, occupationGroups: { ...props.occupationGroups, expanded: false } },
			}
			props.onUpdate(updated)
			props.setOccupationGroups(updated.filter.occupationGroups)
		},
		onCancel: props => () => {
			props.setOccupationGroups({ ...props.search.filter.occupationGroups, expanded: false })
		},
	}),
	withStyles(styles)
)

export default enhance(OccupationGroupFilter)
